import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-close\"><defs><style type=\"text/css\"></style></defs><path d=\"M97.018 1023.854l-97.018-97.018 926.837-926.837 97.018 97.018-926.837 926.837z\" p-id=\"1220\" /><path d=\"M0.277 97.162l97.018-97.018 926.837 926.837-97.018 97.018-926.837-926.837z\" p-id=\"1221\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol